// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2C0GX","offline-title":"style_offline-title__1s9mv","offline-icon":"style_offline-icon__2md7m"};